let mailCapabilityCache: boolean = false;
export function isMailCapabilitySupported(): boolean {
    return mailCapabilityCache;
}

export function setIsMailCapabilitySupported(isSupported: boolean): void {
    mailCapabilityCache = isSupported;
}

let calendarCapabilityCache: boolean = false;
export function isCalendarCapabilitySupported(): boolean {
    return calendarCapabilityCache;
}

export function setIsCalendarCapabilitySupported(isSupported: boolean): void {
    calendarCapabilityCache = isSupported;
}
